// extracted by mini-css-extract-plugin
module.exports = {"list":"LocationReviews_list__kCqgE","root":"LocationReviews_root__XDX6u","title":"LocationReviews_title__0c8p5"};